"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Premiumlounge32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M16 7c.258-.004.509.061.738.194.446.259.709.735.685 1.239a1.517 1.517 0 01-.422 1.026l3.063 4.142c.422.592 1.096.967 1.834 1.02s1.462-.221 1.969-.746l1.866-1.918a1.511 1.511 0 01-.528-1.129c-.015-.774.613-1.415 1.409-1.438.698.047 1.269.561 1.37 1.234s-.293 1.324-.948 1.564c0 .068-.035.136-.035.205l-1.479 6.092a.705.705 0 01-.669.513H7.147a.706.706 0 01-.669-.513l-1.479-6.092c0-.069-.035-.137-.035-.205-.655-.24-1.05-.891-.948-1.564s.672-1.187 1.37-1.234c.796.023 1.425.664 1.409 1.438a1.511 1.511 0 01-.528 1.129l1.866 1.918c.507.525 1.231.799 1.969.746s1.413-.428 1.834-1.02l3.063-4.142a1.519 1.519 0 01-.422-1.026c-.024-.504.24-.98.685-1.239.23-.133.48-.198.738-.194zm9 14.682v1.637c.006.177-.059.348-.179.476s-.287.202-.462.205H7.641a.674.674 0 01-.64-.681v-1.637c-.006-.177.058-.348.179-.477s.287-.202.461-.205h16.718c.36.016.643.317.641.682z" }))); };
var StyledPremiumlounge32 = styled_components_1.default(Premiumlounge32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledPremiumlounge32;
var templateObject_1;
//# sourceMappingURL=Premiumlounge32.js.map